module.exports = __webpack_public_path__ + "assets/img/booth-1.34cb3c1b.png";